import { render, staticRenderFns } from "./PwdNotice.vue?vue&type=template&id=15c8667e"
import script from "./PwdNotice.vue?vue&type=script&lang=js"
export * from "./PwdNotice.vue?vue&type=script&lang=js"
import style0 from "./PwdNotice.vue?vue&type=style&index=0&id=15c8667e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c8667e')) {
      api.createRecord('15c8667e', component.options)
    } else {
      api.reload('15c8667e', component.options)
    }
    module.hot.accept("./PwdNotice.vue?vue&type=template&id=15c8667e", function () {
      api.rerender('15c8667e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PwdNotice.vue"
export default component.exports